export default [
  {
    image:'https://www.airasia.com/aa/bigpay/images/icon_Card.png',
    title: 'Kad',
    url:'https://bigpayme.com/features/card/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_Flight.png',
    title: 'AirAsia 5%',
    url:'https://bigpayme.com/pages/features/bigpayxAA5/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
    image:'https://www.airasia.com/aa/bigpay/images/icon_airasia-points.png',
    title: 'airasia Points',
    url:'https://bigpayme.com/blog/how-to-use-and-earn-airasia-big-points-with-bigpay-bigpay/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money%20page',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_Transfer.png',
    title: 'Pindahan<br/>Antarabangsa',
    url:'https://bigpayme.com/transfers/international-bank-transfers/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_DuitNow.png',
    title: 'DuitNow',
    url:'https://bigpayme.com/features/duitnow/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_bills.png',
    title: 'Bil & Prabayar',
    url:'https://bigpayme.com/blog/introducing-bill-payments-with-bigpay-you-can-now-pay-bills-with-the-bigpay-app/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_analytics.png',
    title: 'Analisis',
    url:'https://bigpayme.com/features/budgeting/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_Stashes.png',
    title: 'Stashes ',
    url:'https://bigpayme.com/blog/save-more-money-with-stashes-by-bigpay/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_loans.png',
    title: 'Pinjaman',
    url:'https://bigpaylater.com.my/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_insurance.png',
      title: 'Insuran <br/>Gaya Hidup',
      url:'https://bigpayme.com/blog/not-insured-just-rm30-yr-gets-you-covered-with-bigpay-s-all-in-one-lifestyle-insurance/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_split.png',
      title: 'Pecah Bill',
      url:'https://bigpayme.com/features/payments/?utm_source=airasia&utm_medium=app&utm_campaign=aa%20money&utm_content=feature%20icon',
  },
  {
      image:'https://www.airasia.com/aa/bigpay/images/icon_Rewards.png',
      title: 'Ganjaran',
      url:'https://bigpay.onelink.me/b8MO/zkq9u6p6',
  }

]
